<script lang="ts">
  import ScreenReaderOnly from "./ScreenReaderOnly.svelte"

  export let progress: number
  export let ariaLabel: string | undefined = undefined

  $: roundedProgress = Math.min(100, Math.max(0, Math.ceil(progress)))
</script>

<div
  role="progressbar"
  aria-label={ariaLabel}
  aria-valuenow={progress}
  aria-valuemin={0}
  aria-valuemax={100}
  class="progress-bar"
>
  <div class="progress-bar__container">
    <div class="progress-bar" style="width: {progress}%">
      <div class="progress-bar-indicator" />
    </div>
  </div>
  <ScreenReaderOnly>{ariaLabel}: {roundedProgress}%</ScreenReaderOnly>
</div>

<style>
  .progress-bar {
    width: 100%;
  }

  .progress-bar__container {
    background-color: var(--aiden-progress-bar-track-color, #999);
    border-radius: var(--aiden-progress-bar-border-radius, 0.75rem);
    position: relative;
    height: 0.5rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & .progress-bar-indicator {
      background-color: var(--aiden-progress-bar-color, #000);
      width: 0.75rem;
      height: 0.75rem;
      border-radius: 50%;
      transform: translateX(50%);
    }

    & .progress-bar {
      border-radius: var(--aiden-progress-bar-border-radius, 0.75rem);
      background-color: var(--aiden-progress-bar-color, #000);
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      min-width: 30px;
      transition: 300ms width ease-out;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 0.5rem;
    }
  }
</style>
